<template>
  <div class="grade-grid-list">
    <button class="btn btn-sm form-control rounded-0" @click="addModule">
      <i class="fas fa-plus-circle"></i> Adicionar Módulo
    </button>

    <div class="grade-grid-list-items p-0">
      <div id="accordionModules">
        <module v-for="item,i in grade" :key="i" :item="item" @loadData="loadData" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Module from './Module'

export default {
  name: "add-course-grade-list",
  components: {
    'module': Module
  },
  computed: {
    ...mapGetters({
      grade: "getNewCourseGrade",
    })
  },
  methods: {
    ...mapActions({
      setGrade: "setGrade"
    }),

    addModule: function () {
      let id = 1
      if ( this.grade.length > 0 ) {
        id = this.grade[ this.grade.length - 1 ].id + 1
      }

      this.setGrade({
        "id": id,
        "name": "Novo Modulo",
        "description": "",
        "module": true,
        "classes": []
      })
    },

    loadData: function ( data ) {
      this.$emit('loadData', data)
    }
  }
}
</script>
